import React from 'react'
import { Card } from '@boulevard/blvd-ui'
import { IBlvdFbIntegration } from '../types'
import fbLogo from '../assets/facebook-logo-small.png'
import igLogo from '../assets/instagram-logo-small.png'
import { Profile } from './Profile'

interface IntegrationProps {
  blvdFbIntegration: IBlvdFbIntegration
}

export const Integration: React.FC<IntegrationProps> = props => {
  return (
    <Card border={1} padding={0} className="card-menu-column">
      {props.blvdFbIntegration.hasFb &&
      <Profile name="Facebook" caption="" logo={fbLogo}
               blvdFbIntegration={props.blvdFbIntegration} showButton={true}/>
      }
      {props.blvdFbIntegration.hasIg &&
        <Profile name="Instagram" caption="" logo={igLogo} blvdFbIntegration={props.blvdFbIntegration}
                 showButton={!props.blvdFbIntegration.hasFb}/>}
    </Card>
  )
}
